import { useHostedPageUrls } from "@propelauth/react";
import EmbedExternalPage from "../shared/embed-external-page";

export default function UserAccount() {
  const urls = useHostedPageUrls();
  const accountUrl = urls.getAccountPageUrl();

  return <EmbedExternalPage url={accountUrl} />;
}
